import { Button, Tooltip } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useNavigate } from "react-router-dom";

import { captureCarrierUpgradeCtaClicked } from "utils";

import {
  CARRIER_UPGRADE_RELATIVE_URL,
  CarrierUpgradeSource,
  ClientAppEvent,
} from "../../../../constants";

export function CompanyNameUpgradeText() {
  const navigate = useNavigate();
  const posthog = usePostHog();

  // Rendered inside a row-level link in the shipment previews, so stop the
  // click from bubbling up and navigating to the shipment instead of upgrade.
  const onSubscribeClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    posthog?.capture(ClientAppEvent.CARRIER_SHIPPER_NAME_SUBSCRIBE_CLICKED);
    captureCarrierUpgradeCtaClicked(
      posthog,
      CarrierUpgradeSource.HIDDEN_SHIPPER_NAME,
    );
    navigate(CARRIER_UPGRADE_RELATIVE_URL);
  };

  return (
    <Tooltip title="Subscribe to a carrier plan to see which company posted this shipment">
      <Button
        variant="text"
        onClick={onSubscribeClick}
        sx={{
          p: 0,
          minWidth: 0,
          fontSize: "inherit",
          fontWeight: "inherit",
          textTransform: "none",
          textDecoration: "underline",
          verticalAlign: "baseline",
        }}
      >
        Subscribe to view shipper name
      </Button>
    </Tooltip>
  );
}
